import * as React from 'react';
import * as styles from './Link.css';

interface ILinkProps extends Omit<React.ComponentPropsWithoutRef<'a'>, 'style' | 'className'> {
  href: string;
}

export const Link: React.FC<ILinkProps> = ({ children, ...props }) => {
  const rel = props.target === '_blank' ? 'noopener' : undefined;

  return (
    // oxlint-disable-next-line react/jsx-no-target-blank
    <a className={styles['link']} rel={rel} {...props}>
      {children}
    </a>
  );
};
